import { useMemo } from 'react';
import { useCloudfrontLocationQuery } from './useCloudfrontLocation';
import { useStoreCountryCode } from './useStoreCountryCode';

// Hook to selectively return the buyer identity country code based on geolocation
export function useBuyerIdentityCountryCode() {
  const storeCountryCode = useStoreCountryCode();
  const { data: cloudfrontLocation } = useCloudfrontLocationQuery();

  // Use geolocated country code if available, otherwise use store default
  const countryCode = useMemo(
    () => cloudfrontLocation?.country || storeCountryCode,
    [cloudfrontLocation, storeCountryCode]
  );

  return countryCode;
}
